import { defineStore } from 'pinia';
import useStore from '@/store/index';
import { Message } from '@/entities';
import { ref } from 'vue';

export default defineStore('message', () => {
  const rootStore = useStore();
  const messages = ref<Message[]>([]);
  const isLoading = ref(false);

  return {
    messages,
    isLoading,

    async init() {},
    async getMessages() {
      isLoading.value = true;
      const cmsLocale = rootStore.user.cmsLocale;
      const data = await rootStore.apiService.message.fetchMessages(cmsLocale);

      if (data) {
        messages.value = data.map((messageData) => new Message(messageData));
      }
      isLoading.value = false;
    },
    async markAsRead(messageId: string) {
      const message = messages.value.find((m) => m.id === messageId);

      if (message) {
        const isMessageUpdated = await rootStore.apiService.message.markAsRead(messageId);

        if (isMessageUpdated) {
          message.isRead = true;
        }
      }
    }
  };
});
